import { render, staticRenderFns } from "./RoomSelector.vue?vue&type=template&id=45ce8265&scoped=true&"
import script from "./RoomSelector.vue?vue&type=script&lang=js&"
export * from "./RoomSelector.vue?vue&type=script&lang=js&"
import style0 from "./RoomSelector.vue?vue&type=style&index=0&id=45ce8265&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce8265",
  null
  
)

export default component.exports